import "./form-package-transport.scss";

import { PackageTransportFormSchema } from "@factory/form/form.rule";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";

import { useQyGetTransportType } from "../../../factory/query/transport-type.query";
import { useQyGetUtilTransportLocation } from "../../../factory/query/util-transport-location.query";
import { LabelValue } from "../../../shared/models/label-value.interface";
import DropdownControl from "../../../shared/ui/hook-form/dropdown-control/dropdown-control";

type InputFormSchema = PackageTransportFormSchema;
export function FormPackageTransport() {
  const { control, setValue } = useFormContext<PackageTransportFormSchema>();
  const { packageId } = useParams();
  const [transportTypes, setTransportTypes] = useState<LabelValue[]>([]);
  const [transportLocations, setTransportLocations] = useState<LabelValue[]>(
    []
  );
  setValue("package", packageId);

  // THIS IS THE LOCAL QUERY DECLARATION
  useQyGetTransportType("", 9999, 0, undefined, undefined, true, (response) => {
    const mappedSuggestions = (response?.data || [])
      .map((item) => ({
        label: `${item.name}`,
        value: item.code,
      }))
      .filter((x) => !!x.label);
    // Set the suggestions for the dropdown control
    setTransportTypes(mappedSuggestions);
  });

  useQyGetUtilTransportLocation(
    "",
    9999,
    0,
    undefined,
    undefined,
    true,
    (response) => {
      const mappedSuggestions = (response?.data || [])
        .map((item) => ({
          label: `${item.name}`,
          value: item.code,
        }))
        .filter((x) => !!x.label);
      // Set the suggestions for the dropdown control
      setTransportLocations(mappedSuggestions);
    }
  );

  return (
    <div id="FormPackageTransport" className="package-transport">
      <DropdownControl<InputFormSchema>
        control={control}
        name={`transportType`}
        label="Transport Type"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter transport type"
        options={transportTypes}
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name={`fromLocation`}
        label="From"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter from location"
        options={transportLocations}
      />
      <DropdownControl<InputFormSchema>
        control={control}
        name={`toLocation`}
        label="To"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter to location"
        options={transportLocations}
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="pricePerPax"
        label="Price_per_pax"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter pricePerPax"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="numPeople"
        label="Num_people"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter numPeople"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="unit"
        label="Unit"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter unit"
      />
      <InputDigitControl<InputFormSchema>
        control={control}
        name="amount"
        label="Amount"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter amount"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
    </div>
  );
}

export default FormPackageTransport;
